import { render, staticRenderFns } from "./asshow.vue?vue&type=template&id=03f47094&scoped=true&"
import script from "./asshow.vue?vue&type=script&lang=js&"
export * from "./asshow.vue?vue&type=script&lang=js&"
import style0 from "./asshow.vue?vue&type=style&index=0&id=03f47094&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f47094",
  null
  
)

export default component.exports